import { useState, useEffect } from "react";
import TodoForm from "../TodoForm/TodoForm";
import TodoList from "../TodoList/TodoList";
import styles from "../../mainPage.module.css";

const ResrvApp = ({ todos, setTodos, allUserTag }) => {
  const addTodoHandler = (valueDateStart, valueDatePayan, price, valJazebe) => {
    const newTodo = {
      id: Math.floor(Math.random() * 1000),
      stm: valueDateStart,
      prepay: price,
      ftm: valueDatePayan,
      user_tag_id: valJazebe,
    };
    setTodos([...todos, newTodo]);
  };

  const deleteHandler = (id) => {
    const filteredTodos = todos.filter((todo) => todo.id !== id);
    setTodos(filteredTodos);
  };

  return (
    <div className={styles.inputBox3}>
      <TodoForm addTodoHandler={addTodoHandler} allUserTag={allUserTag} />
      <TodoList todos={todos} deleteHandler={deleteHandler} />
    </div>
  );
};

export default ResrvApp;
